import appMobileEscl from '../locales/es-CL/appMobile.json';
import appMobileEsmx from '../locales/es-MX/appMobile.json';
import appMobileEsco from '../locales/es-CO/appMobile.json';
import appMobileEnus from '../locales/en-US/appMobile.json';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

import DriverService from '../services/DriverService';
import LogService from '../services/LogService';
import Container from 'typedi';
import showConfirmation from '../confirmation/confirmationHandler';

import axios from 'axios';

export default {
  name: 'AppMobile',
  components: {Multiselect,VueCtkDateTimePicker},
  i18n: {
    messages: {
      'es-CL': {
        appMobile: appMobileEscl,
      },
      'es-MX': {
        appMobile: appMobileEsmx,
      },
      'es-CO': {
        appMobile: appMobileEsco,
      },
      'en-US': {
        appMobile: appMobileEnus,
      },
    },
  },
  data() {
    return {
        dataAcces: null,
        currentTab: "managementApp",
        selectedAllDrivers: false,
        isMainPageBussy: false,
        filterName: null,
        driversSelected: [],
        driversInfoApp: [],
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 15, 20, 50, 100],
        isFilterShown: false,
        isFilterApplied: false,
        isFilterClicked: false,
        filters: {
          clients: [],
          appVersion: [],
          gpsPermissionType: [
            {
              value: 'notEnabled',
            },
            {
              value: 'onlyAppInUse',
            },
            {
              value: 'allowed'
            },
            {
              value: 'notFind'
            }
          ],
          connection: [
            {
              value: 'high'
            },
            {
              value: 'intermediate'
            },
            {
              value: 'low'
            },
            {
              value: 'notSignal'
            },
          ],
          motorEnable: [
            {
              name: this.$t('appMobile.motorEnable.enabled'),
              value: true
            },
            {
              name: this.$t('appMobile.motorEnable.disabled'),
              value: false
            }
          ],
        },
        formFilter:{
          clients: [],
          appVersion: null,
          gpsPermissionType: null,
          connection: null,
          motorEnable: null,
          lastLogin: {
            start: null,
            end: null,
          },
        },
        client: null,
        connecting: false,
        receiveNews: null,
        logService: null,
        lastAppVersion: null,
        driverService: null,
        countDownId: null,
        currentSortBy: null,
        refreshCountDown: 0,
        refreshCountDownStart: 10,
    }
  },
  async created() {
    this.driverService = Container.get(DriverService);
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: { 
    async prepareData(){
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      const includeOnlyUsers = true;
      const drivers = await this.driverService.getDrivers(includeOnlyUsers);
      this.lastAppVersion = await this.getAppLastVersion();
      let appParameters;
      if(drivers && drivers.length > 0){
        const idDrivers = drivers.map(driver => driver.id);
        const idClients = [... new Set(drivers.map(driver => driver.idClient))];
        idClients.forEach( async (idClient)=>{
          const client = await this.getClientById(idClient);
          if(client){
            this.filters.clients.push(client);
          }
        })
        //appParameters = await this.getAppParamsTemporal(idDrivers);
        appParameters = await this.getAppParamsTemporal(idDrivers);
      }
      this.driversInfoApp = await this.transformData(drivers,appParameters);
      
      this.isMainPageBussy = false;
    },
    async transformData(drivers, appParameters){
      const infoAppDriver = [];
      await drivers.forEach(async (driver)=>{
        let body = {
          idUser: driver.id,
          driverName: driver.firstName && driver.lastName ? `${driver.firstName} ${driver.lastName}` : driver.firstName,
          bussyHandlePermission: false,
        }
        if(appParameters && appParameters.length > 0){
          const appParameterDriver = appParameters.find((appParam) => appParam.idUser == driver.id);
          if(appParameterDriver){
            body = {
              ...body,
              lastLoginTimestamp: appParameterDriver.lastLogin ? appParameterDriver.lastLogin : null,
              lastLogin: appParameterDriver.lastLogin ? moment(new Date(appParameterDriver.lastLogin)).format('DD-MM-YYYY') : 'notFind',
              appVersion: appParameterDriver.version ? appParameterDriver.version : 'notFind',
              signal: appParameterDriver.signal != undefined ? appParameterDriver.signal : 'notFind',
              intensitySignal: appParameterDriver.intensitySignal ? appParameterDriver.intensitySignal : 'notSignal',
              gpsPermissionType: appParameterDriver.gpsPermission ? appParameterDriver.gpsPermission : 'notFind',//Viene en lowerCase desde el back
              motorEnable: appParameterDriver.isGpsManagementActive != undefined ? appParameterDriver.isGpsManagementActive : false,
            }
            this.filters.appVersion.push(appParameterDriver.version);
          }
        }
        if(this.filters.clients.length > 0){
          const clientData = this.filters.clients.find((client)=> client.id === driver.idClient);
          body = {
            ...body,
            idClient: driver.idClient,
            clientName: clientData ? clientData.name : 'notFind',
          }
        }
        infoAppDriver.push(body);
      });

      this.filters.appVersion = [...new Set(this.filters.appVersion)];
      return this.sortWithRules(infoAppDriver);
    },
    async getAppParamsTemporal(idDrivers){
      console.log("idDrivers.length ", idDrivers.length)
      let result = [];
      let limitLength = 0;
      let filterUser = [];
      for (let i = 0; i < idDrivers.length; i++) {
        filterUser.push(`idUsers=${idDrivers[i]}`);
        if (limitLength > 200) {
          try{
            const filterQuery = filterUser.join('&');
            const url = `${this.$store.getters.urlAPI}/appParam?${filterQuery}`;
            const config = {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            };
            const response =  await axios.get(url, config);
            response.data.data.forEach((data)=>{
              result.push(data);
            })
            console.log("limitLength ", limitLength)
            limitLength = 0;
            filterUser = [];
          }catch(e){
            console.log(e);
            this.logService.sendError({
              component: "appMobile",
              message: `getAppParams fallo ${e.message}`
            });
          }
        } else {
          limitLength++;
          console.log("limitLength ", limitLength)
        }
      }
      if (limitLength > 0) {
        try{
          const filterQuery = filterUser.join('&');
          const url = `${this.$store.getters.urlAPI}/appParam?${filterQuery}`;
          const config = {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          };
          const response =  await axios.get(url, config);
          response.data.data.forEach((data)=>{
            result.push(data);
          })
        }catch(e){
          console.log(e);
          this.logService.sendError({
            component: "appMobile",
            message: `getAppParams fallo ${e.message}`
          });
        }
      }
      console.log("result final ", result.length)
      return result;
    },
    async getAppParams(idDrivers){
      try{
        const filterUser = [];
        idDrivers.forEach((id)=>{
          filterUser.push(`idUsers=${id}`);
        })
        console.log(new Date().getTime())

        const filterQuery = filterUser.join('&');
        const url = `${this.$store.getters.urlAPI}/appParam?${filterQuery}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response =  await axios.get(url, config);
        return response.data.data;
      }catch(e){
        console.log(e);
        this.logService.sendError({
          component: "appMobile",
          message: `getAppParams fallo ${e.message}`
        });
        return [];
      }
    },
    async getClientById(idClient){
      try{
        const url = `${this.$store.getters.urlAPI}/api/client/${idClient}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response =  await axios.get(url, config);
        return response.data.data;
      }catch(e){
        console.log(e);
        this.logService.sendError({
          component: "appMobile",
          message: `getClientById ${idClient} fallo ${e.message}`
        });
        return null;
      }
    },
    async getAppLastVersion(){
      try{
        const url = `${this.$store.getters.urlAPI}/m/appVersionV2`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response =  await axios.get(url, config);
        return response.data.data.version;
      }catch(e){
        console.log(e);
        this.logService.sendError({
          component: "appMobile",
          message: `getAppLastVersion fallo ${e.message}`
        });
        return "";
      }
    },
    limitText(count) {
      return this.$t('appMobile.limitText') + (count + 1);
    },
    async handleManagementPermission(appParam, actualState){
      try{
        appParam.bussyHandlePermission = true;
        console.log("Datos que se van a enviar ",appParam, appParam.motorEnable, actualState);
        const body = {
          idUser: appParam.idUser,
          isGpsManagementActive: actualState
        }
        const url = `${this.$store.getters.urlAPI}/appParam/gpsManagement`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response =  await axios.post(url, body, config);
        if(response.status){
          const appParamOrigin = this.driversInfoApp.find((app)=> app.idUser == appParam.idUser);
          if(appParamOrigin){
            appParamOrigin.motorEnable = actualState
            appParamOrigin.bussyHandlePermission = false;
          }
        }
      }catch(e){
        const appParamOrigin = this.driversInfoApp.find((app)=> app.idUser == appParam.idUser);
        if(appParamOrigin){
          appParamOrigin.motorEnable = !actualState
          appParamOrigin.bussyHandlePermission = false;
        }
        console.log(e);
        this.logService.sendError({
          component: "appMobile",
          message: `handleManagementPermission fallo ${e.message}`
        });
        return [];
      }

    },
    getSignalTransformation(signal){
      let signalText = null;
      if(signal > -60){
        signalText = this.$t("appMobile.signalIntensity.high");
      }else if(signal <= -60 && signal >= -89){
        signalText = this.$t("appMobile.signalIntensity.intermediate");
      }else if(signal <= -90 && signal >= -200){
        signalText = this.$t("appMobile.signalIntensity.low");
      }else{
        signalText = this.$t("appMobile.signalIntensity.notSignal");
      }
      return signalText
    },
    confirmActivePermission(){
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('appMobile.confirm.massActive', {totalDrivers: this.driversSelected.length}),
        ()=>{
          this.handleMassivePermission('ACTIVE');
        });
    },
    confirmUnactivePermission(){
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('appMobile.confirm.massUnactive', {totalDrivers: this.driversSelected.length}),
        ()=>{
          this.handleMassivePermission('DEACTIVATE');
        });
    },

    async handleMassivePermission(handler){
      const body = [];
      this.driversSelected.forEach((idDriver)=>{
        const appParam = this.driversInfoApp.find((driverFiltered) => driverFiltered.idUser === idDriver);
        //Si voy a activar, entonces solamente quiero activar los que no estan activados
        if(handler == 'ACTIVE' && appParam && !appParam.motorEnable){
          appParam.bussyHandlePermission = true;
          body.push({
            idUser: appParam.idUser,
            isGpsManagementActive: true
          })
        }
        //Si voy a desactivar, entonces solamente quiero deactivar los que no estan desactivados
        else if(handler === 'DEACTIVATE' && appParam.motorEnable){
          appParam.bussyHandlePermission = true;
          body.push({
            idUser: appParam.idUser,
            isGpsManagementActive: false
          })
        }
      });
      try{
        const url = `${this.$store.getters.urlAPI}/appParam/massiveGpsManagement`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        this.logService.sendInfo({
          component: "appMobile",
          message: `handleMassivePermission consultara appParam/massiveGpsManagement para ${handler} ${body.length}`,
          data: this.driversSelected,
        });
        const response =  await axios.post(url, body, config);
        if(response.status){
          //Si salio bien la actualización masiva entonces le quito el estado de cargando a cada conductor marcado
          this.changeStatusAppParam(body, handler, false);
        }
      }catch(e){
        console.log(e);
        this.changeStatusAppParam(body, handler, true);
        this.logService.sendError({
          component: "appMobile",
          message: `handleMassivePermission fallo ${e.message}`
        });
      }
    },
    changeStatusAppParam(body, handler, manteinMotorPermission){
      //Como ya desactive el bussy al conductor, y gestione su permiso de motor, entonces vació la lista de conductores seleccionados
      this.driversSelected = [];
      this.selectedAllDrivers = false;
      body.forEach((driver)=>{
        const appParam = this.driversInfoApp.find((driverFiltered) => driverFiltered.idUser === driver.idUser);
        if(appParam){
          appParam.bussyHandlePermission = false;          
          if(handler == 'ACTIVE'){
            appParam.motorEnable = !manteinMotorPermission;
          }
          //Si voy a desactivar, entonces solamente quiero deactivar los que no estan desactivados
          else if(handler === 'DEACTIVATE'){
            appParam.motorEnable = manteinMotorPermission;
          }
        }
      });
    },
    sortWithRules(array){
      return array.sort((a, b) => {
        // 2. Priorizar los que tienen el campo booleano como true
        if (a.motorEnable !== b.motorEnable) {
          return a.motorEnable === true ? -1 : 1;
        }
        // 1. Ordenar por nombre alfabéticamente
        const nameCompare = a.driverName.localeCompare(b.driverName);
        if (nameCompare !== 0) return nameCompare;
      
      
        // 3. Ordenar por fecha (ascendente)
        return new Date(a.lastLoginTimestamp) - new Date(b.lastLoginTimestamp);
      });
    },
    async refreshData(){
      try{
        if(this.driversInfoApp.length > 0){
          const idDrivers = this.driversInfoApp.map(driver => driver.idUser);
          //const appParameters = await this.getAppParamsTemporal(idDrivers);
          const appParameters = await this.getAppParamsTemporal(idDrivers);
          this.filters.appVersion = [];
          //Vamos a actualizar los datos existentes de los conductores
          this.driversInfoApp.forEach((driver)=>{
            if(appParameters && appParameters.length > 0){
              const appParameterDriver = appParameters.find((appParam) => appParam.idUser == driver.idUser);
              if(appParameterDriver){
                driver.lastLoginTimestamp = appParameterDriver.lastLogin ? appParameterDriver.lastLogin : null;
                driver.lastLogin = appParameterDriver.lastLogin ? moment(new Date(appParameterDriver.lastLogin)).format('DD-MM-YYYY') : 'notFind';
                driver.appVersion = appParameterDriver.version ? appParameterDriver.version : 'notFind';
                driver.signal = appParameterDriver.signal != undefined ? appParameterDriver.signal : 'notFind';
                driver.intensitySignal = appParameterDriver.intensitySignal ? appParameterDriver.intensitySignal : 'notSignal';
                //Viene en lowerCase desde el back
                driver.gpsPermissionType = appParameterDriver.gpsPermission ? appParameterDriver.gpsPermission : 'notFind';
                this.filters.appVersion.push(appParameterDriver.version);
              }
            }
          });
          this.currentSortBy = null;
          this.filters.appVersion = [...new Set(this.filters.appVersion)];
          this.driversInfoApp = this.sortWithRules(this.driversInfoApp);
        }
      }catch(e){
        this.logService.sendError({
          component: "appMobile",
          message: `refreshData fallo al intentar refrescar la data  ${e.message}`
        });
      }
    },
    isVersionValid(version) {
      try{
        // Extraemos los números de la versión base
        const [baseMajor, baseMinor] = this.lastAppVersion.split('.').map(Number);
        const [major, minor, patch] = version.split('.').map(Number);
        
        // Comparamos las versiones
        if (major > baseMajor) {
          return true; // La versión es mayor
        }
        
        if (major === baseMajor) {
          if (minor > baseMinor) {
            return true; // La versión es igual en mayor y es mayor en minor
          }
          
          if (minor === baseMinor) {
            return patch >= 0; // La versión es igual en mayor y minor, chequeamos patch
          }
        }
        
        return false; // La versión es menor
      }catch{
        return false;
      }
    },
    startCountDownTimer() {
      this.refreshCountDown = this.refreshCountDownStart;
      this.refreshData();
      this.countDownTimer();
    },
    countDownTimer() {
      if (this.refreshCountDown > 0) {
        this.countDownId = setTimeout(() => {
          this.refreshCountDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    stopUpdating() {
      // Cancela el temporizador si está activo
      if (this.countDownId !== null) {
        clearTimeout(this.countDownId);
        console.log('Temporizador cancelado');
      }
    },
    //Esto parsea los datos provenientes del back, por lo tanto la validación es en lowercase
    keyToTextGpsPermission(gpsPermission){
        let name = null;
        if(gpsPermission == 'notEnabled'.toLowerCase()){
          name = this.$t("appMobile.gpsPermission.notEnabled");
        }else if(gpsPermission == 'onlyAppInUse'.toLowerCase()){
          name = this.$t("appMobile.gpsPermission.onlyAppInUse");
        }else if(gpsPermission == 'allowed'){
          name = this.$t("appMobile.gpsPermission.allowed");
        }else{
          name = this.$t("appMobile.notFind");
        }
        return name;
    },
    cleanFilter(){
      this.currentSortBy = null;
      this.formFilter = {
        clients: [],
        appVersion: null,
        gpsPermissionType: null,
        connection: null,
        motorEnable: null,
        lastLogin: {
          start: null,
          end: null,
        },
      };
    },
    changeTab(newTab){
        this.currentTab = newTab;
    },
    checkDrivers(){
        if (this.selectedAllDrivers) {
          this.checkAllDrivers();
        } else {
          this.unCheckAllDrivers();
        }
    },
    checkAllDrivers(){
        this.driversSelected = [];
        for (const driver of this.filtered) {
          this.driversSelected.push(driver.idUser);
        }
    },
    unCheckAllDrivers(){
        this.driversSelected = [];
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    appParamsItems(listParams){
      return listParams.map((appParam)=>{
        return {
          ...appParam,
          gpsPermissionType: this.keyToTextGpsPermission(appParam.gpsPermissionType),
          signal: this.getSignalTransformation(appParam.signal)
        }
      })
    },
  },
  beforeDestroy() {
    // Detener la actualización cuando el componente se destruya
    this.stopUpdating();
  },
  computed: {
    getAppVersionOptions(){
      const appVersionList = [];
      appVersionList.push(
        {
          name: this.$t('appMobile.updated'),
          value: 'updated'
        });
      appVersionList.push(
        {
          name: this.$t('appMobile.outdated'),
          value: 'outdated'
        });
      this.filters.appVersion.forEach((version)=>{
        if(version){
          appVersionList.push({
            name: version,
            value: version
          });
        }
      })
      appVersionList.push(
        {
          name: this.$t('appMobile.notFind'),
          value: 'notFind'
        });
      return appVersionList;
    },
    gpsPermissionOptions(){
      return this.filters.gpsPermissionType.map((gpsPermission)=>{
        let name = null;
        if(gpsPermission.value == 'notEnabled'){
          name = this.$t("appMobile.gpsPermission.notEnabled");
        }else if(gpsPermission.value == 'onlyAppInUse'){
          name = this.$t("appMobile.gpsPermission.onlyAppInUse");
        }else if(gpsPermission.value == 'allowed'){
          name = this.$t("appMobile.gpsPermission.allowed");
        }else{
          name = this.$t('appMobile.notFind');
        }
        return {
          ...gpsPermission,
          name: name
        }
      })
    },
    connectionOptions(){
      return this.filters.connection.map((connection)=>{
        let name = null;
        if(connection.value === 'high'){
          name = this.$t("appMobile.signalIntensity.high");
        }
        if(connection.value === 'intermediate'){
          name = this.$t("appMobile.signalIntensity.intermediate");
        }
        if(connection.value === 'low'){
          name = this.$t("appMobile.signalIntensity.low");
        }
        if(connection.value === 'notSignal'){
          name = this.$t("appMobile.signalIntensity.notSignal");
        }
        return {
          ...connection,
          name: name
        }
      })
    },
    filtered(){
      let auxInfoDriver = this.driversInfoApp;
      let filterApplied = false;
      if(this.filterName){
        auxInfoDriver = auxInfoDriver.filter((driver)=>driver.driverName.toUpperCase().includes(this.filterName.toUpperCase()));
      }      
      console.log(this.formFilter.clients)
      console.log(this.formFilter.clients.length)
      if(this.formFilter.clients && this.formFilter.clients.length > 0){
        filterApplied = true;
        console.log(this.formFilter.clients);
        auxInfoDriver = auxInfoDriver.filter((driver) => {
          if (driver.idClient !== null || driver.idClient !== undefined) {
            return this.formFilter.clients.some((client) => {
              if(client != undefined){
                return client.id === driver.idClient;
              }
            });
          }
        });
      }
      if(this.formFilter.gpsPermissionType){
        filterApplied = true;
        auxInfoDriver = auxInfoDriver.filter((driver)=>driver.gpsPermissionType.toLowerCase() == this.formFilter.gpsPermissionType.value.toLowerCase());
      }
      if(this.formFilter.connection && this.formFilter.connection.value != undefined){
        filterApplied = true;
        auxInfoDriver = auxInfoDriver.filter((driver)=>driver.intensitySignal == this.formFilter.connection.value);
      }
      if(this.formFilter.appVersion && this.formFilter.appVersion !=undefined){
        filterApplied = true;
        if(this.formFilter.appVersion.value === 'updated'){
          auxInfoDriver = auxInfoDriver.filter((driver)=>this.isVersionValid(driver.appVersion));
        }else if(this.formFilter.appVersion.value === 'outdated'){
          auxInfoDriver = auxInfoDriver.filter((driver)=> !this.isVersionValid(driver.appVersion));
        }
        else {
          auxInfoDriver = auxInfoDriver.filter((driver)=>driver.appVersion == this.formFilter.appVersion.value);
        }
      }
      if(this.formFilter.lastLogin && this.formFilter.lastLogin.start){
        filterApplied = true;
        auxInfoDriver = auxInfoDriver.filter((driver)=>{
          if(driver.lastLogin != 'N/A'){
            const date = moment(new Date(driver.lastLoginTimestamp)).format('YYYY-MM-DD');
            if(this.formFilter.lastLogin.start && this.formFilter.lastLogin.end){
              return date >= this.formFilter.lastLogin.start && date <= this.formFilter.lastLogin.end;
            }else{
              return date === this.formFilter.lastLogin.start;
            }
          }
        });
      }
      if(this.formFilter.motorEnable && this.formFilter.motorEnable.value != undefined){
        filterApplied = true;
        auxInfoDriver = auxInfoDriver.filter((driver)=>driver.motorEnable == this.formFilter.motorEnable.value);
      }

      this.isFilterApplied = filterApplied;
      return this.appParamsItems(auxInfoDriver);
    },
    shortCuts(){
      return [
        { key: 'thisWeek', label: this.$t(`appMobile.shortcuts.thisWeek`), value: 'isoWeek' },
        { key: 'lastWeek', label: this.$t(`appMobile.shortcuts.lastWeek`), value: '-isoWeek' },
        { key: 'last7Days', label: this.$t(`appMobile.shortcuts.last7Days`), value: 7 },
        { key: 'last14Days', label: this.$t(`appMobile.shortcuts.last14Days`), value: 14 },
        { key: 'last30Days', label: this.$t(`appMobile.shortcuts.last30Days`), value: 30 },
        { key: 'thisMonth', label: this.$t(`appMobile.shortcuts.thisMonth`), value: 'month' },
      ]
    },
    appMobileFields(){
        const common = {
            class: 'text-left',
            tdClass: 'small',
          };
          return [
            {
              key: 'select',
              label: '',
              ...common,
            },
            {
              key: 'driverName',
              label: this.$t('appMobile.table.driverName'),
              sortable: true,
              ...common,
            },
            {
              key: 'clientName',
              label: this.$t('appMobile.table.clientName'),
              sortable: true,
              ...common,
            },
            {
              key: 'gpsPermissionType',
              label: this.$t('appMobile.table.permissions'),
              sortable: true,
              ...common,
            },
            {
              key: 'signal',
              label: this.$t('appMobile.table.connection'),
              sortable: true,
              ...common,
            },
            {
              key: 'appVersion',
              label: this.$t('appMobile.table.appVersion'),
              sortable: true,
              ...common,
            },
            {
              key: 'lastLogin',
              label: this.$t('appMobile.table.lastConnection'),
              sortable: true,
              ...common,
            },
            {
              key: 'motorEnable',
              label: this.$t('appMobile.table.motorEnable'),
              class: 'text-center',
            },
          ];
    },
  }
};
